import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Partner } from 'src/app/models/partner.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { PartnerService } from 'src/app/services/partner.service';
import { StripeService } from 'src/app/services/stripe.service';
import { CustomerCardInfoComponent } from '../customer-card-info/customer-card-info.component';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-partner-stripe-card',
  templateUrl: './partner-stripe-card.component.html',
  styleUrls: ['./partner-stripe-card.component.scss']
})
export class PartnerStripeCardComponent implements OnInit {

  groups: string[];
  limit: number;
  page: number;
  count: number = 0;
  maxPage: number;
  order: { [key: string]: string } = {};
  selected = "active";
  defaultPage = 1;
  defaultLimit = 50;
  defaultOrder = { 'StripeCustomer.id': 'DESC' };
  filtered = {};
  stripeCustomerFilterForm: any;
  stripeCustomers: any[] = [];
  loggedInPartner: Partner;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commanUsesService: CommanUsesService,
    private stripeService: StripeService,
    private authStatusService: AuthStatusService,
    private partnerService: PartnerService,
    public dialog: MatDialog,
    public spinnerService: SpinnerService,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }
  
  async ngOnInit() {
    try {
      this.spinnerService.show();
      const loggedInUserInfo = await this.authStatusService.getTokenInfo();
      this.manageStripeCustomerFilterForm();
      if(this.groups.includes('partner')){
        this.loggedInPartner = await this.partnerService.getOne(loggedInUserInfo['extraId']);
      }
      await this.filter();
      this.spinnerService.hide();
    } catch (error) {
      let errorMsg = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errorMsg);
      this.spinnerService.hide();
    }
  }

  async manageStripeCustomerFilterForm() {
    this.stripeCustomerFilterForm = new FormGroup({
      'StripeCustomer.id': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'StripeCustomer.stripeCustId': new FormControl(''),
      'StripeCustomer.partnerId': new FormControl(''),
    })
  }

  async filter() {

    let filterForm = (new FormGroupToObject()).transform(this.stripeCustomerFilterForm);
    this.filtered = {};
    if (filterForm['StripeCustomer.id'])
      this.filtered['StripeCustomer.id'] = filterForm['StripeCustomer.id'];  
    if (filterForm['Partner.businessName'])
      this.filtered['Partner.businessName'] = { operator: 'like', values: [`%${filterForm['Partner.businessName']}%`]};
    if (filterForm['StripeCustomer.stripeCustId'])
      this.filtered['StripeCustomer.stripeCustId'] = { operator: 'like', values: [`%${filterForm['StripeCustomer.stripeCustId']}%`]};

    if(this.groups.includes('partner') && this.loggedInPartner) {
      this.filtered['StripeCustomer.partnerId'] = this.loggedInPartner.id; 
    }

    await this.loadStripeCustomers();
  }

  async resetFliter() {
    await this.manageStripeCustomerFilterForm();
    await this.filter();
  }

  async loadStripeCustomers(limit?: number, page?: number, order?: {}) {
    try {
      this.page  = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
      this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
      this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;

      let stripeCustomers = await this.stripeService.getAllStripeCustomers(this.page, this.limit, this.order, this.filtered);
      this.stripeCustomers = stripeCustomers.stripeCustomers;
      this.count = stripeCustomers.count;
      this.maxPage = Math.ceil(this.count / this.limit);
    } catch (error) {
      
    }
  }

  async showCustomerDetails(customer) {
    try {
      const ref = this.dialog.open(CustomerCardInfoComponent, { width: '80vw', data: { customer } });
    } catch (error) {
      
    }
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  public async navigateOrder(attribute: string | string[]) {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.loadStripeCustomers();
    });
  }

  async navigate(event) {
    await this.loadStripeCustomers(event.limit, event.page, this.order);
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

}
